import { API_ROOT_URL } from '../config';
import { handleResponse } from '../helpers';
import axios from 'axios';
import moment from 'moment';

export const appointmentService = {
	getPatients,
	getAppointments,
	createAppointment,
	cancelAppointment,
	getCounsellarInfo,
	setCounsellorStatus,
	getPatientsList,
	capturePaypalOrder,
	createFailedPaymentLog,
	createAppointmentV2,
	updateAppointment,
	getCallStatus,
	requestSession,
	requestSessionB2C,
	requestAppointment,
	arrangeSession,
	getPatientDetail,
	getSessionCaps
};

function createAppointmentV2(current_time, slotTime, patient_id) {
	const token = JSON.parse(localStorage.getItem('token'));
	const requestOptions = {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json',
			Authorization: 'Bearer ' + token,
		},
		body: JSON.stringify({
			current_time: current_time,
			date_time: slotTime,
			patient_id: patient_id,
			payment: 'notrequired',
		}),
	};
	return fetch(`${API_ROOT_URL}/appointments/counsellor_appointment/`, requestOptions).then((handleResponse) => {
		return handleResponse;
	});
}

function getPatientDetail(patientId){
	const token = JSON.parse(localStorage.getItem('token'))
	const requestOptions = {
		method: 'GET',
		headers: {
			'Content-Type': 'application/json',
			Authorization: 'Bearer ' + token,
		},
	};

	return fetch(`${API_ROOT_URL}/patients/${patientId}/detail`, requestOptions)
		.then(handleResponse)
		.then((userSession) => {
			return userSession;
		});

}

function getSessionCaps(patientId){
	const token = JSON.parse(localStorage.getItem('token'))
	const requestOptions = {
		method: 'GET',
		headers: {
			'Content-Type': 'application/json',
			Authorization: 'Bearer ' + token,
		},
	};

	return fetch(`${API_ROOT_URL}/patients/sessioncaps`, requestOptions)
		.then(handleResponse)
		.then((session_caps) => {
			return session_caps;
		});

}

function getPatients() {
	const token = JSON.parse(localStorage.getItem('token'));

	const requestOptions = {
		method: 'GET',
		headers: {
			'Content-Type': 'application/json',
			Authorization: 'Bearer ' + token,
		},
	};

	return fetch(`${API_ROOT_URL}/counsellors/services/my_patients/`, requestOptions)
		.then(handleResponse)
		.then((userSession) => {
			return userSession;
		});
}

function getPatientsList() {
	const token = JSON.parse(localStorage.getItem('token'));

	const requestOptions = {
		method: 'GET',
		headers: {
			'Content-Type': 'application/json',
			Authorization: 'Bearer ' + token,
		},
	};

	return fetch(`${API_ROOT_URL}/counsellors/my_patients/`, requestOptions)
		.then(handleResponse)
		.then((userSession) => {
			return userSession;
		});
}

function getAppointments(id) {
	const token = JSON.parse(localStorage.getItem('token'));
	const requestOptions = {
		method: 'GET',
		headers: { Authorization: 'Bearer ' + token },
	};
	return fetch(`${API_ROOT_URL}/appointments/my_appointments/`, requestOptions).then(response => handleResponse(response))
	.then(data => {
		return data;
	});
}

function createAppointment(appointmentDetails, counsellor_id) {
	const token = JSON.parse(localStorage.getItem('token'));
	const requestOptions = {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json',
			Authorization: 'Bearer ' + token,
		},
		body: JSON.stringify(appointmentDetails),
	};
	return fetch(`${API_ROOT_URL}/appointments/set_appointment_v2/?q=${counsellor_id}`, requestOptions).then(
		(handleResponse) => {
			return handleResponse;
		}
	);
}

function createFailedPaymentLog(appointmentDetails, counsellor_id) {
	const token = JSON.parse(localStorage.getItem('token'));

	const body = JSON.stringify(appointmentDetails);

	return axios
		.post(`${API_ROOT_URL}/appointments/set_appointment_v2/?q=${counsellor_id}`, body, {
			headers: {
				'Content-Type': 'application/json',
				Authorization: 'Bearer ' + token,
			},
		})
		.then(function (response) {
			return response;
		})
		.catch(function (error) {
			// handle error
			console.log('Error Fetching createFailedPaymentLog');
		});
}

function capturePaypalOrder(orderId) {
	const token = JSON.parse(localStorage.getItem('token'));
	const requestOptions = {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json',
			Authorization: 'Bearer ' + token,
		},
		body: JSON.stringify(orderId),
	};
	return fetch(`${API_ROOT_URL}/appointments/capture_order/`, requestOptions).then((handleResponse) => {
		return handleResponse;
	});
}

function cancelAppointment(value) {
	const token = JSON.parse(localStorage.getItem('token'));

	const requestOptions = {
		method: 'PUT',
		headers: {
			'Content-Type': 'application/json',
			Authorization: 'Bearer ' + token,
		},
	};
	return fetch(`${API_ROOT_URL}/appointments/${value}/`, requestOptions).then(response => handleResponse(response,false))
	.then(data => {
		return data;
	});
}

function getCounsellarInfo(id) {
	const token = JSON.parse(localStorage.getItem('token'));

	const requestOptions = {
		method: 'GET',
		headers: {
			'Content-Type': 'application/json',
			Authorization: 'Bearer ' + token,
		},
	};
	return fetch(`${API_ROOT_URL}/counsellors/${id}/`, requestOptions).then((handleResponse) => {
		return handleResponse;
	});
}

function setCounsellorStatus(status) {
	const token = JSON.parse(localStorage.getItem('token'));
	const requestOptions = {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json',
			Authorization: 'Bearer ' + token,
		},
		body: JSON.stringify(status),
	};
	return fetch(`${API_ROOT_URL}/counsellors/set_status/`, requestOptions).then((handleResponse) => {
		return handleResponse;
	});
}

function updateAppointment(appointmentId, updateSchedule) {
	const token = JSON.parse(localStorage.getItem('token'));
	const requestOptions = {
		method: 'PATCH',
		headers: {
			'Content-Type': 'application/json',
			Authorization: 'Bearer ' + token,
		},
		body: JSON.stringify({ update_time: updateSchedule }),
	};
	return fetch(`${API_ROOT_URL}/appointments/${appointmentId}/`, requestOptions).then((handleResponse) => {
		return handleResponse;
	});
}

function getCallStatus() {
	const token = JSON.parse(localStorage.getItem('token'));

	const requestOptions = {
		method: 'GET',
		headers: {
			'Content-Type': 'application/json',
			Authorization: 'Bearer ' + token,
		},
	};

	return fetch(`${API_ROOT_URL}/appointments/get_all_call_status/`, requestOptions)
		.then(handleResponse)
		.then((userSession) => {
			return userSession;
		});
}

function requestSession(schedule, counsellor_id) {
	const token = JSON.parse(localStorage.getItem('token'));
	const project_id = localStorage.getItem('project_id');
	const requestOptions = {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json',
			Authorization: 'Bearer ' + token,
		},
		body: JSON.stringify({
			date_time: schedule,
			counsellor_id: counsellor_id,
			project_id: project_id,
		}),
	};
	return fetch(`${API_ROOT_URL}/appointments/request_appointment/`, requestOptions)
		.then(response => handleResponse(response,false))
		.then(data => {
			return data;
		});
}

function requestSessionB2C(counsellor_id) {
	const token = JSON.parse(localStorage.getItem('token'));
	const project_id = localStorage.getItem('project_id');
	const requestOptions = {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json',
			Authorization: 'Bearer ' + token,
		},
		body: JSON.stringify({
			counsellor_id: counsellor_id,
			project_id: project_id,
		}),
	};
	return fetch(`${API_ROOT_URL}/appointments/request_appointment_b2c/`, requestOptions).then((handleResponse) => {
		return handleResponse;
	});
}

function requestAppointment(schedule, patient_id) {
	const token = JSON.parse(localStorage.getItem('token'));
	const requestOptions = {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json',
			Authorization: 'Bearer ' + token,
		},
		body: JSON.stringify({
			current_time: moment(new Date()).utc().format(),
			date_time: schedule,
			patient_id: patient_id,
		}),
	};
	return fetch(`${API_ROOT_URL}/appointments/create_request_appointment/`, requestOptions).then(
		(handleResponse) => {
			return handleResponse;
		}
	);
}

function arrangeSession(counsellorId, projectId) {
	const token = JSON.parse(localStorage.getItem('token'));
	const requestOptions = {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json',
			Authorization: 'Bearer ' + token,
		},
		body: JSON.stringify({
			counsellor_id: counsellorId,
			project_id: projectId,
		}),
	};
	return fetch(`${API_ROOT_URL}/appointments/request_appointment/`, requestOptions)
		.then(response => handleResponse(response,false))
		.then(data => {
			return data;
		});
}



// WEBPACK FOOTER //
// ./src/services/appointment.service.js